const ALERT_TYPES = {
  error: 'error',
  warning: 'warning',
  info: 'info',
  success: 'success',
}

const state = () => ({
  alert: '',
  type: ALERT_TYPES.error,
})

const getters = {
  alert: state => state.alert,
  type: state => (state.type) ? state.type : ALERT_TYPES.error,
}

const mutations = {
  setAlert(state, payload) {
    state.alert = payload.alert
    state.type = payload.type
  }
}

const actions = {
  setAlert: ({ commit }, payload) => {
    commit('setAlert', payload)
  }
}

export default {
  state,
  getters,
  mutations,
  actions,
}
